import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=a9c43fee&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=a9c43fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c43fee",
  null
  
)

export default component.exports